// extracted by mini-css-extract-plugin
export default {"device-image":"YJdt","deviceImage":"YJdt","device-image-placeholder":"B69b","deviceImagePlaceholder":"B69b","button-group":"H8zn","buttonGroup":"H8zn","button":"cHMQ"};